import React, { useMemo, ReactElement } from 'react';
import LocationMap from '../../../components/location-map/location-map.component';
import Widget from '../../../components/widget/widget.component';
import { WIDGET_NAME_DEAL_LOCATIONS } from '../../../constants/system/widget-names';
import { ROUTE_DEAL } from '../../../constants/system/routes';
import { MARKER_COLOR_RED } from '../../../constants/entity/marker-colors';

const DashboardWidgetDealLocations: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const WIDGET_TITLE_DEFAULT: string = 'Deal Locations';

  const {
    assetList,
    portfolioList,
    widgetSettings,
    onWidgetSettingsChange,
  } = props;

  const withAssetsLocation: boolean = assetList && !!assetList.length
    ? !!assetList.filter((assetItem: Asset): boolean => !!assetItem.latitude && !!assetItem.longitude).length : false;

  const portfolioMarkerColorIdList: number[] = useMemo((): number[] => (
    portfolioList && portfolioList.length ? portfolioList.map((portfolioItem: Portfolio): number | null => (
      portfolioItem.markerColor ? portfolioItem.markerColor.id : null
    )).filter((portfolioMarkerColorId: number | null): boolean => !!portfolioMarkerColorId) as number[] : []
  ), [portfolioList]);
  const assetLocationItemList: LocationMapItem[] = useMemo((): LocationMapItem[] => (
    assetList && assetList.length
      ? assetList.map((assetItem: Asset): LocationMapItem => ({
        id: assetItem.id,
        title: assetItem.lastDeal ? assetItem.lastDeal.name : null,
        color: (assetItem.portfolio && assetItem.portfolio.markerColor && assetItem.portfolio.markerColor
          && assetItem.portfolio.markerColor.name) || null,
        link: assetItem.lastDeal ? `${ROUTE_DEAL}/${assetItem.lastDeal.id}` : null,
        amount: (assetItem.lastDeal && assetItem.lastDeal.amount) || null,
        imageLink: assetItem.mainPhotoThumbnail || assetItem.mainPhoto,
        latitude: assetItem.latitude || null,
        longitude: assetItem.longitude || null,
      })) : []
  ), [assetList]);

  return (
    <Widget
      withCustomizeMode
      isEmpty={!withAssetsLocation || !assetLocationItemList || !assetLocationItemList.length}
      widgetName={WIDGET_NAME_DEAL_LOCATIONS}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
      widgetSettings={widgetSettings}
      onWidgetSettingsChange={onWidgetSettingsChange}
    >
      <LocationMap
        defaultColor={MARKER_COLOR_RED}
        colorIdList={portfolioMarkerColorIdList}
        locationItemList={assetLocationItemList}
      />
    </Widget>
  );
});

export default DashboardWidgetDealLocations;
